module.exports = __webpack_public_path__ + "images/visa.26648971ea53d9fec01b00c39f86939d.svg";